import classnames from 'classnames';
import propTypes from 'prop-types';
import React from 'react';
import styles from './SearchSwitch.scss';

const TAB_ENTRIES = 'entries';
const TAB_RESULTS = 'results';

const BASE_PATH = '/bloodstock/sales/search';

const options = [
    { label: 'Entries', key: TAB_ENTRIES },
    { label: 'Results', key: TAB_RESULTS },
];

export default function SearchSwitch({ className, tab }) {
    return (
        <div className={`${styles.root} ${className}`}>
            <div className={`${styles.switch} ui-switcher`}>
                {options.map(({ label, key }) => (
                    <a
                        key={key}
                        className={classnames(
                            styles.link,
                            'ui-switcher__btn ui-btn ui-btn_small',
                            key === tab ? 'ui-btn_primary' : 'ui-btn_secondary'
                        )}
                        href={`${BASE_PATH}/${key}`}
                    >
                        <span className="ui-switcher__title">{label}</span>
                    </a>
                ))}
            </div>
        </div>
    );
}

SearchSwitch.TAB_ENTRIES = TAB_ENTRIES;
SearchSwitch.TAB_RESULTS = TAB_RESULTS;

SearchSwitch.propTypes = {
    className: propTypes.string,
    tab: propTypes.oneOf([TAB_ENTRIES, TAB_RESULTS]).isRequired,
};

SearchSwitch.defaultProps = {
    className: '',
};



// WEBPACK FOOTER //
// ./src/js/Search/Switch/SearchSwitch.jsx